import React from 'react';
import { Alert, Button } from 'reactstrap';
import { formatPrice } from '../../helpers/utility';

export const GuidedPaymentStepper = ({ activeStep = 1, onStepChange }) => {
  const steps = [
    'Informations du règlement',
    'Documents à régler',
    'Répartition du montant',
    'Vérification et confirmation',
  ];

  return (
    <nav className="guided-payment-stepper" aria-label="Étapes du règlement">
      {steps.map((label, index) => {
        const number = index + 1;
        return (
          <Button
            key={label}
            type="button"
            color={number === activeStep ? 'primary' : 'light'}
            className={`guided-payment-step ${number < activeStep ? 'is-complete' : ''}`}
            onClick={() => onStepChange(number)}
            aria-current={number === activeStep ? 'step' : undefined}
          >
            <span className="guided-payment-step-number">{number}</span>
            <span className="guided-payment-step-label">
              <span>{label}</span>
              {number < activeStep && <small>Modifier</small>}
            </span>
          </Button>
        );
      })}
    </nav>
  );
};

export const PaymentHelp = ({ children, color = 'info' }) => (
  <Alert color={color} className="payment-context-help" role="note">
    {children}
  </Alert>
);

export const PaymentFinancialSummary = ({
  paymentAmount,
  allocatedAmount,
  currentPaymentAllocated,
  advanceAmount = 0,
  partyKind = 'client',
}) => {
  const payment = Number(paymentAmount || 0);
  const externalAdvance = Number(advanceAmount || 0);
  const totalCoverage = Number(allocatedAmount || 0);
  const fundedByPayment = currentPaymentAllocated === undefined
    ? Math.max(0, totalCoverage - externalAdvance)
    : Number(currentPaymentAllocated || 0);
  const unapplied = Math.max(0, payment - fundedByPayment);
  const excess = Math.max(0, fundedByPayment - payment);

  return (
    <aside className="payment-financial-summary" aria-live="polite">
      <div className="payment-financial-summary-title">
        Résumé du règlement
      </div>
      <dl>
        <div><dt>Montant du règlement</dt><dd>{formatPrice(paymentAmount || 0, false)} DH</dd></div>
        {externalAdvance > 0 && <div><dt>Avances externes utilisées</dt><dd>{formatPrice(externalAdvance, false)} DH</dd></div>}
        <div><dt>Total couvert</dt><dd>{formatPrice(totalCoverage, false)} DH</dd></div>
        <div><dt>Reste disponible</dt><dd>{formatPrice(unapplied, false)} DH</dd></div>
      </dl>
      {excess > 0 ? (
        <Alert color="danger" className="mb-0 py-2">
          Le montant affecté dépasse le montant disponible de {formatPrice(excess, false)} DH.
        </Alert>
      ) : unapplied > 0 ? (
        <Alert color="warning" className="mb-0 py-2">
          Le solde restera disponible comme avance {partyKind}.
        </Alert>
      ) : totalCoverage > 0 ? (
        <Alert color="success" className="mb-0 py-2">Le règlement est entièrement affecté.</Alert>
      ) : (
        <Alert color="info" className="mb-0 py-2">
          Aucun document sélectionné : ce règlement sera enregistré comme avance non affectée.
        </Alert>
      )}
    </aside>
  );
};
